module.exports = __webpack_public_path__ + "fonts/Roboto-BlackItalic.3a99796b.woff";